import { useCallback, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';

import { ControlVisitModal } from './control-visit-modal';
import { INotification } from '../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { getControlVisitNotifications } from '../../utils';
import { useCvBonusInfo } from '../../../../../../hooks';
import { InternalLinks } from '../../../../../../constants';
import { EcpServices } from '../../../ecp-locator';
import { useCvInfoModal } from '../../../../../../hooks/use-cv-info-modal';
import { setCvTerms } from '../../../../../../graphql';

export const useControlVisitModal = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const cvTerms = useReactiveVar(setCvTerms);
  const { cvBonusPoints, cvBonusEndDate, fromDays, toDays, code, isCvPeriodActive, isLoading } = useCvBonusInfo(true);
  const { handleCvDetailsClick } = useCvInfoModal({
    points: cvBonusPoints,
    fromDays,
    toDays,
    endDate: cvBonusEndDate,
    code,
    isLoading,
  });
  const [isShow, setIsShow] = useState(true);

  const handleAppointmentClick = useCallback(
    () => navigate(`${InternalLinks.ecpLocator}?ecpService=${EcpServices.cv}&storeGroupCode=${code}`),
    [navigate, code],
  );

  const handleControlVisitModal = useCallback((
    notifications: INotification[], updateNotifications: (notificationId: string) => void,
  ) => {
    if (isShow && cvBonusPoints && cvBonusEndDate && isCvPeriodActive) {
      const { id: notificationId } = notifications[0];

      showModal(ControlVisitModal, {
        notificationId,
        cvBonusPoints,
        cvBonusEndDate,
        onCvDetailsClick: handleCvDetailsClick,
        updateNotifications,
        onAppointmentClick: handleAppointmentClick,
      });

      setIsShow(false);
    }
  }, [
    showModal,
    cvBonusPoints,
    cvBonusEndDate,
    isCvPeriodActive,
    handleAppointmentClick,
    getControlVisitNotifications,
    handleCvDetailsClick,
    cvTerms,
    isShow,
    setIsShow,
  ]);

  return { handleControlVisitModal };
};
